import ClintPhone from './clint-phone.js';

export default class PhoneFields {

	constructor (groups) {
		this.groups = groups;
		this.init();
	}

	init () {
		for (const group of this.groups) {
			this.initGroup(group);
		}
	}

	initGroup (group) {
		const phone = group.querySelector('[data-phone-display]');
		const ext = group.querySelector('[data-phone-ext-display]');
		const hidden = group.querySelector('[data-phone-hidden]');

		if (!phone || !ext || !hidden) {
			return;
		}

		const sync = () => {
			const parsed = ClintPhone.parse(hidden.value);

			phone.value = ClintPhone.formatDisplay(parsed.phone);
			ext.value = parsed.ext;
		};

		// PREFILL — split the saved record into the two visible fields.
		if (hidden.value) {
			sync();
		}

		// No maxlength on the input — a browser maxlength blocks typing/pasting
		// past the cap silently, which leaves the customer guessing why nothing
		// happens. Instead, anything past the cap is allowed in but flagged.
		// setCustomValidity folds our check into the field's native validity,
		// so it plays nicely with HTMLFormValidator's own required/pattern
		// checks on the same field instead of overriding them — the message is
		// swapped in only while the length check is actually the failing reason.
		phone.addEventListener('input', () => {
			const overLimit = phone.value.length > ClintPhone.CONFIG.displayMaxLength;

			if (overLimit) {
				phone.setAttribute('data-error-message', ClintPhone.CONFIG.displayMaxLengthMessage);
			} else {
				phone.removeAttribute('data-error-message');
			}

			phone.setCustomValidity(overLimit ? ClintPhone.CONFIG.displayMaxLengthMessage : '');

			if (phone.form && phone.form.HTMLFormValidator) {
				phone.form.HTMLFormValidator.validateFormElement(phone);
			}
		});

		// Picking a saved address writes straight into this hidden field
		// (ToggleDetails.js, loaded separately) without firing an event on it,
		// so re-split it once the selector that drives that script changes.
		// The deferral lets that script's own listener run first regardless
		// of which one was bound to the selector second.
		const selectorId = hidden.name.indexOf('Ship') !== -1 ? 'shipping_selector' : 'billing_selector';
		const selector = document.getElementById(selectorId);

		if (selector) {
			selector.addEventListener('change', () => setTimeout(sync, 0));
		}

		if (!phone.form) {
			return;
		}

		// SUBMIT — recombine. No validation, no blocking.
		phone.form.addEventListener('submit', () => {
			hidden.value = ClintPhone.format(phone.value, ext.value);
		});
	}

}
